import axiosIns from '@axios'

const getLocationService = async ({ searchInput, date, status, company, type, page, limit, filterType, userFilter, paginated = true }) => {
    if(paginated){
        return axiosIns.get(`/location/paginated`, { params: { company,name: searchInput, state:status, page, limit }})
    }else{
        return axiosIns.get(`/location/all`, { params: { company,name: searchInput, state:status, page, limit }})
    }
}

const getLocationByIdService = async ({ locationId }) => {
    return await axiosIns.get(`/location/${locationId}`)
}

const updateScheduleService = async ({ locationId, updateScheduleObject }) => {
    //its seems redundant but the idea of this is let this method to add the needed logic before sending to the backend
    return await axiosIns.patch(`/location/${locationId}/schedule`, updateScheduleObject)
}

const updateLocationService = async ({ locationId, updateLocationObject }) => {
    return await axiosIns.patch(`/location/${locationId}`, updateLocationObject)
}

export {
    getLocationService,
    updateScheduleService,
    getLocationByIdService,
    updateLocationService
}